import { render } from "./bank-info.vue?vue&type=template&id=b3f38f0a&scoped=true"
import script from "./bank-info.vue?vue&type=script&lang=js"
export * from "./bank-info.vue?vue&type=script&lang=js"

import "./bank-info.vue?vue&type=style&index=0&id=b3f38f0a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3f38f0a"]])

export default __exports__